module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": _vm.errorMessage
    }
  }, [_c('Button', {
    attrs: {
      "bordered": true,
      "autowidth": true
    },
    on: {
      "click": _vm.closeMessages
    }
  }, [_vm._v("Закрыть")])], 1) : [_c('InnerMenu', {
    attrs: {
      "menu": _vm.innerMenu
    }
  }), _c('router-view', {
    attrs: {
      "items": _vm.programs
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a60343f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/programs/MentoringPrograms.vue
// module id = a6461937c43ed51ed9dd
// module chunks = 65